<panel width="700">
	<h1>{{ 'page-title.overridden-due-dates' | translate }}</h1>
	@if (!customers) { <skeleton /> }
	@else {
		<list-view scrollable>
			<header>{{ 'accounting.due-dates.external-link' | translate }}</header>
			<header>{{ 'accounting.due-dates.invoice-number' | translate }}</header>
			<header align-right>{{ 'accounting.due-dates.wanted-due-date' | translate }}</header>
			<row *listData="let customer from customers" [groupBy]="customer.company?.name" [clickable]="false" target="_blank">
				<column><a href="{{ getInvoiceUrl(customer.customerNumber) }}" target="_blank">{{ getInvoiceUrl(customer.customerNumber) }}</a></column>
				<column>{{ customer.invoiceNumber }}</column>
				<column align-right>{{ customer.dueDate | customDate: 'shortDate' }}</column>
			</row>
		</list-view>
	}
</panel>
